import axios from 'axios';

let AXIOS_CONFIG_DATA;

export function setAxiosConfigData(data) {
  AXIOS_CONFIG_DATA = data;
}

function axiosFetch(url, options = { method: 'get' }, headers = {}) {
  const axiosConfig = {
    url: url,
    baseURL: '/personal-investor/pam',
    timeout: 30000,
    method: options.method,
    credentials: 'include',
    withCredentials: true,
    headers: {
      Accept: 'application/json',
      'x-trp-requested-with': '1',
      'cache-control': 'no-cache',
      'content-Type': '*/*',
      'Access-Control-Allow-Credentials': true,
      apikey: AXIOS_CONFIG_DATA,
      ...headers
    }
  };

  return axios.request(axiosConfig);
}

export default axiosFetch;
